import EditorConfig from '../Components/Editor/Config.svelte';
import EditorInfo from '../Components/Editor/Info.svelte';
import EditorProduct from '../Components/Editor/Product.svelte';
import EditorQuotation from '../Components/Editor/Quotation.svelte';
import Empty from '../Components/Widgets/Empty.svelte';
import MenuConfig from '../Components/Menu/Config.svelte';
import MenuInfo from '../Components/Menu/Info.svelte';
import MenuProduct from '../Components/Menu/Product.svelte';
import MenuQuotation from '../Components/Menu/Quotation.svelte';
import TitleConfig from '../Components/Title/Config.svelte';
import TitleInfo from '../Components/Title/Info.svelte';
import TitleProduct from '../Components/Title/Product.svelte';
import TitleQuotation from '../Components/Title/Quotation.svelte';
import {writable} from 'svelte/store';

let data = {type: 'empty', editor: Empty, menu: Empty, title: Empty};
const layout = writable(data);

layout.empty = () => {
	const type = 'empty';
	if (data.type != type) {
		data = {type, editor: Empty, menu: Empty, title: Empty};
		layout.set(data);
	}
};

layout.info = () => {
	const type = 'info';
	if (data.type != type) {
		data = {type, editor: EditorInfo, menu: MenuInfo, title: TitleInfo};
		layout.set(data);
	}
};

layout.product = () => {
	const type = 'product';
	if (data.type != type) {
		data = {type, editor: EditorProduct, menu: MenuProduct, title: TitleProduct};
		layout.set(data);
	}
};

layout.quotation = () => {
	const type = 'quotation';
	if (data.type != type) {
		data = {type, editor: EditorQuotation, menu: MenuQuotation, title: TitleQuotation};
		layout.set(data);
	}
};

layout.config = () => {
	const type = 'config';
	if (data.type != type) {
		data = {type, editor: EditorConfig, menu: MenuConfig, title: TitleConfig};
		layout.set(data);
	}
};

export default layout;